<template>
	<v-btn text :loading="loading" @click="toDownloadPage">
		<v-icon size="20px" left>mdi-download-outline</v-icon>
		<span class="text-capitalize">Télécharger</span>
	</v-btn>
</template>

<script>
import { generateKeyForStorage } from '@/utils/download-expression-answer';
export default {
	name: 'DownloadExpressionAnswer',
	props: { formattedText: String, originalText: String },
	data() {
		return { loading: false };
	},
	methods: {
		async toDownloadPage() {
			this.loading = true;
			const { formationId, sessionId, sessionBlockId, trackId } = this.$route.params;

			try {
				this.temporarySaveData(formationId, sessionId, sessionBlockId, trackId); // save text to local storage to use in PrintTrackExpressionAnswer

				const route = this.$router.resolve({
					name: 'PrintTrackExpressionAnswerPage',
					params: { formationId, sessionId, sessionBlockId, trackId },
				});
				window.open(route.href, '_blank');
			} catch (error) {
				console.error('Error downloading PDF:', error);
			} finally {
				this.loading = false;
			}
		},
		temporarySaveData(formationId, sessionId, sessionBlockId, trackId) {
			const key = generateKeyForStorage(formationId, sessionId, sessionBlockId, trackId);
			const data = {
				formattedText: this.formattedText,
				originalText: this.originalText,
			};
			localStorage.setItem(key, JSON.stringify(data));
		},
	},
};
</script>

<style lang="scss" scoped></style>
